/** @format */

import React, { FC, useState } from "react";
import {
	View,
	Text,
	TextInput as TextInputNative,
	StyleSheet,
	ViewStyle,
	Platform,
} from "react-native";
import { useTheme } from "../theme/colors";

export interface CustomTextInputChangeEvent {
	name: string;
	value: string;
}

interface CustomTextInputProps {
	title?: string;
	name: string;
	defaultValue?: string;
	placeholder?: string;
	multiline?: boolean;
	hideInput?: boolean;
	fieldStyles?: ViewStyle;
	fieldFocusStyles?: ViewStyle;
	onChangeText?: (event: CustomTextInputChangeEvent) => void;
	required?: boolean;
	editable?: boolean;
	onFocus?: (event: any) => void;
	onBlur?: (event: { name: string }) => void;
	autoFocus?: boolean;
	scrollEnabled?: boolean;
}

const CustomTextInput: FC<CustomTextInputProps> = ({
	title,
	name,
	defaultValue = "",
	onChangeText,
	multiline,
	hideInput,
	placeholder,
	fieldStyles,
	fieldFocusStyles,
	required,
	editable,
	onFocus,
	onBlur,
	autoFocus,
	scrollEnabled,
}) => {
	const [foucs, setFoucs] = useState(false);
	const theme = useTheme();
	const hideOutlineStyleForWeb =
		Platform.OS === "web" && ({ outlineWidth: 0 } as ViewStyle);
	const customTextInputStyles = getCustomTextInputStyles(theme);
	const focusStyles = foucs
		? {
				...customTextInputStyles.focusField,
				...fieldFocusStyles,
		  }
		: undefined;

	const onChangeTextHandle = (value: string) => {
		onChangeText?.({
			name,
			value,
		});
	};

	const onBlurTextHandle = (event: any) => {
		onBlur?.({
			name,
		});
	};

	const renderRequired = () => {
		if (!required) {
			return null;
		}
		return <Text style={customTextInputStyles.required}>*</Text>;
	};

	if (Boolean(hideInput)) {
		return null;
	}
	return (
		<View style={customTextInputStyles.viewContainer}>
			{title && (
				<Text style={customTextInputStyles.title}>
					{title} {renderRequired()}
				</Text>
			)}
			<TextInputNative
				defaultValue={defaultValue}
				style={[
					customTextInputStyles.textInput,
					fieldStyles,
					hideOutlineStyleForWeb,
					focusStyles,
				]}
				multiline={multiline}
				scrollEnabled={scrollEnabled}
				numberOfLines={1}
				placeholder={placeholder}
				placeholderTextColor={theme.LIGHT_GREY}
				onChangeText={onChangeTextHandle}
				onBlur={(event) => {
					setFoucs(false);
					onBlurTextHandle(event);
				}}
				onFocus={(event) => {
					setFoucs(true);
					onFocus && onFocus(event);
				}}
				inputMode="text"
				editable={editable}
				autoFocus={autoFocus}
			/>
		</View>
	);
};

export default CustomTextInput;

const getCustomTextInputStyles = (theme: Record<string, string | number>) => {
	return StyleSheet.create({
		viewContainer: {
			gap: 5,
		},
		title: {
			fontSize: 14,
			width: "100%",
			color: theme.TEXT as string,
			fontWeight: "300",
		},
		textInput: {
			width: "100%",
			paddingHorizontal: 10,
			paddingVertical: 10,
			color: theme.TEXT as string,
			backgroundColor: theme.BACKGROUND_SECONDARY as string,
		},
		textInputContent: {
			color: theme.TEXT as string,
		},
		focusField: {
			borderBottomWidth: 2,
			borderBottomColor: theme.ACCENT as string,
		},
		required: {
			color: "crimson",
		},
	});
};
